import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { DeepPartial, ISearchCashbackWalletRequest, ISearchTransactionRequest, ISearchTransactionResponse, ISearchWalletResponse } from '@lib/interfaces';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BillPaymentService {
    public environment_url: string;

    public constructor(private readonly http: HttpClient) {
        this.environment_url = environment.api_url;
    }

    public searchTransactions(searchPayload: DeepPartial<ISearchTransactionRequest>): Observable<ISearchTransactionResponse> {
        return this.http.post<ISearchTransactionResponse>(`${this.environment_url}nfront/v1/proxy/transactions:search`, searchPayload);
    }

    public fetchBillCountries(): Observable<any> {
        return this.http.get<any>(`${this.environment_url}nfront/v1/proxy/remittances/bilrs/countries`);
    }

    public fetchBillCategories(): Observable<any> {
        return this.http.get<any>(`${this.environment_url}nfront/v1/proxy/biller/categories`);
    }

    public fetchBillCategoryById(categoryId: string): Observable<any> {
        return this.http.get<any>(`${this.environment_url}nfront/v1/proxy/biller/categories/${categoryId}/service-providers`);
    }

    public fetchBillerdetails(countryCode: string): Observable<any> {
        return this.http.get<any>(`${this.environment_url}nfront/v1/proxy/billpayments/billerdetails?country=${countryCode}`);
    }

    public fetchServiceDetails(serviceCode: string): Observable<any> {
        return this.http.get<any>(`${this.environment_url}nfront/v1/proxy/biller/service-providers/${serviceCode}/services`);
    }

    public fetchPaymentDetails(billerId: string): Observable<any> {
        return this.http.get<any>(`${this.environment_url}nfront/v1/proxy/remittances/paymentdetails/${billerId}`);
    }

    public performPaymentInquiry(payload: any): Observable<any> {
        return this.http.post<any>(`${this.environment_url}nfront/v1/proxy/billpayments/paymentinquiry`, payload);
    }

    public billersFieldInquiry(serviceCode: string) {
        return this.http.get<any>(`${this.environment_url}nfront/v1/proxy/biller/service/${serviceCode}/fields`);
    }

    public billersPaymentInquiry(serviceCode: string, payload: any): Observable<any> {
        return this.http.post<any>(`${this.environment_url}nfront/v1/proxy/biller/service/${serviceCode}/inquiry`, payload);
    }

    public performBillerPayment(serviceCode: string, senderAccountId: string, payload: any) {
        const headers = new HttpHeaders({
            'x-nymos-idempotency-key': crypto.randomUUID(),
        });
        return this.http.post<any>(`${this.environment_url}nfront/v1/proxy/biller/service/${serviceCode}/transaction/${senderAccountId}`, payload, { headers });
    }

    public performPayment(payload: any): Observable<any> {
        return this.http.post<any>(`${this.environment_url}nfront/v1/proxy/remittances/performpayment`, payload);
    }

    public getFxRateQuote(payload: any) {
        return this.http.post(`${this.environment_url}nfront/v1/proxy/fxrates:quote`, payload);
    }
}
